import { createRouter, createWebHistory } from "vue-router";

import HomeView from "@/views/HomeView";
//import ComingSoonView from "@/views/ComingSoonView.vue";
// To be added...
// let publicPath = process.env.VUE_APP_SERVICE_URL +VUE_APP_PLATFORM === 'LOCAL' ? '/dev/gaudeamus' : '/'

const routes = [
  { path: "/", name: "home", component: HomeView },
  { path: "/a7f4c2d9e8b1k6m3p5q0z7x2", name: "homedev", component: HomeView },
  //{ path: "/", name: "ComingSoon", component: ComingSoonView },
  //{path: '/category/:id', name: 'category', component: CategoryView},
  //{path: '/products', name: 'products', component: ProductsView},
  //{path: '/product/:id', name: 'product', component: DetailsView},
  //{path: '/cart/', name: 'cart', component: ShoppingCart},
  //{path: '/checkout/', name: 'checkour', component: CheckoutOrder},
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
